import * as yup from "yup";

import { LessonTopicPageModel, LessonTopicPageModelValidationRules } from "./LessonTopicPageModel";

export const LessonTopicPageCreateModelValidationSchema = yup.object().shape<LessonTopicPageModel>({
    Name: LessonTopicPageModelValidationRules.Name,
    IsAssessable: LessonTopicPageModelValidationRules.IsAssessable,
    LessonTopicID: LessonTopicPageModelValidationRules.LessonTopicID,
});
